// actionTypes.js
export const START_PREP_MODE = 'START_PREP_MODE';
export const STOP_PREP_MODE = 'STOP_PREP_MODE';
export const START_CLEAN_MODE = 'START_CLEAN_MODE';
export const CLOCK_OUT = 'CLOCK_OUT';
export const UPDATE_ELAPSED_TIME = 'UPDATE_ELAPSED_TIME';
export const START_BREAK = 'START_BREAK';
export const END_BREAK = 'END_BREAK';
export const UPDATE_PREV_SECONDS = 'UPDATE_PREV_SECONDS'
export const UPDATE_START_TIME = 'UPDATE_START_TIME'
// actions.js

export const startPrepMode = (tmName, date) => ({
    type: START_PREP_MODE,
    payload: { tmName, date }
});

export const stopPrepMode = () => ({
    type: STOP_PREP_MODE
});

export const startCleanMode = () => ({
    type: START_CLEAN_MODE
});

export const clockOut = () => ({
    type: CLOCK_OUT
});

export const updateElapsedTime = (elapsedTime) => ({
    type: UPDATE_ELAPSED_TIME,
    payload: elapsedTime
});

export const startBreak = (elapsedTime) => ({
    type: START_BREAK,
    payload: elapsedTime
});

export const endBreak = () => ({
    type: END_BREAK
});

export const updatePrevSeconds = (data) => ({
    type: UPDATE_PREV_SECONDS,
    payload: data
})

export const updateStartTime = (data) => ({
    type: UPDATE_START_TIME,
    payload: data
})